/**
 *
 * Angular Application Controllers.
 *
 */

var forestControllers = angular.module('forestControllers', ['forestServices', 'ui.router']);

forestControllers.controller('mainController', function ($scope, _, $timeout,
                                                         $rootScope, $state, $element, User, $http, FormMaterials,
                                                         $stateParams, Server, Calc, dialogs,
                                                         /*Following parameters are comming from server*/
                                                         dropDownData,
                                                         tanrigisCxrili,
                                                         userInput, /*Passport data - Available when editing existing document.*/
                                                         forma6, /*Forma6 data - Available when editing existing document.*/
                                                         forma1 /*Forma1 data - Available when editing existing document.*/) {

    /**
     * Code related to Koordinatebi UI these are dynamic fields and require
     * additional logic.
     */
    $scope.coords = [{x: undefined, y: undefined}];

    $scope.addCoord = function () {
        var newItemNo = $scope.coords.length + 1;
        $scope.coords.push({x: undefined, y: undefined});
    };

    $scope.removeCoord = function () {

        if ($scope.coords.length <= 1) {
            return;
        }

        var lastItem = $scope.coords.length - 1;

        // Reset model values for these fields, this also helps
        // to avoid sending hidden fields on server
        if ($scope.userInput && $scope.userInput.koordinatebi) {
            $scope.userInput.koordinatebi['X' + lastItem]
                = $scope.userInput.koordinatebi['Y' + lastItem]
                = undefined;
        }

        $scope.coords.splice(lastItem);
    };

    $scope.coordXRegX = '[0-9][0-9][0-9][0-9][0-9][0-9]';
    $scope.$watch(function () {
        return $scope.userInput.koordinatebi_zona_id;
    }, function (newVal) {
        if (newVal == 1) { // If Zona is N37
            $scope.coordXRegX = '7[0-9][0-9][0-9][0-9][0-9]';
        } else {
            $scope.coordXRegX = '[0-9][0-9][0-9][0-9][0-9][0-9]';
        }
    });

    /**
     * Prepare stuff for tanrigi calculations.
     */
    $scope.tanrgisCxrili = tanrigisCxrili;
    $scope.simaglesBySaxeoba = [];
    $scope.diametrisBySaxeoba = [];
    $scope.tanrigisBySaxeoba = [];

    $.each(tanrigisCxrili, function (i, el) {
        //console.log("Saxeoba key: ", i);
        $scope.simaglesBySaxeoba[i] = getUniqueProperties(el, 'simagle', true);
        $scope.diametrisBySaxeoba[i] = getUniqueProperties(el, 'diametri', true);
        $scope.tanrigisBySaxeoba[i] = getUniqueProperties(el, 'tanrigi', false);
    });

    /**
     * Assign arrays for select menus on $scope.
     *
     */
    for (var d in dropDownData) {
        if (dropDownData.hasOwnProperty(d)) {
            $scope[d] = dropDownData[d];
        }
    }

    /**
     * Needed in some cases.
     */
    $scope.currentlyEditing = $stateParams.edit;

    /**
     * Forma 1 UI requires little bit preparation to work properly
     *
     */
    $scope.initializeForma1JsonObject = function (param) {

        $scope.forma1Meta = param ? param : {};
        $scope.forma1Meta.saxeobaInputs = param && param.saxeobaInputs ? param.saxeobaInputs : [];
        $scope.forma1Meta.hOne = param && param.hOne ? param.hOne : [];
        $scope.forma1Meta.hTwo = param && param.hTwo ? param.hTwo : [];
        $scope.forma1Meta.hThree = param && param.hThree ? param.hThree : [];
        $scope.forma1Meta.avgDiameter = param && param.avgDiameter ? param.avgDiameter : [];
        $scope.forma1Meta.tanrigi = param && param.tanrigi ? param.tanrigi : [];
        $scope.forma1Meta.smallTrees = param && param.smallTrees ? param.smallTrees : [];

    }

    $scope.initializeForma1JsonObject();

    $scope.f1 = {};
    $scope.f1.trees = [];

    /**
     * If editing propagate existing data on UI
     *
     */
    $scope.userInput = {};

    if ($stateParams.edit) {
        /**
         * Propagate existing Passport date on UI
         *
         */

        $scope.userInput = _.clone(userInput);

        /**
         * TODO: This timeout helps to wait for init-datepicker directive to run otherwise we loose values
         * currently we are using non angular datepicker, there are plenty bs datepickers for
         * angular maybe we can take one of them
         */

        $timeout(function () {
            $scope.userInput.dawyebis_tarigi = userInput.dawyebis_tarigi;
            $scope.userInput.damtavrebis_tarigi = userInput.damtavrebis_tarigi;
        }, 0);

        $scope.userInput.literebi = $.map(userInput.literebi, function (el) {
            return el.id;
        });

        if (userInput.koordinatebi) {
            var i = 1;
            while (userInput.koordinatebi['X' + i] || userInput.koordinatebi['Y' + i]) {
                $scope.addCoord();
                i++;
            }
        }

        /**
         * Propagate existing Forma6 date on UI
         *
         */
        $scope.f6 = forma6;

        /**
         * Propagate existing Forma1 date on UI
         *
         */

        $scope.initializeForma1JsonObject(forma1.meta);
        $scope.f1.trees = forma1.trees;

        $scope.treeIndex = forma1.trees && forma1.trees.length > 0
            ? Math.max.apply(Math, forma1.trees.map(function (o) {
            return o.nomeri;
        }))
            : undefined;
    }

    //console.log('tanrigisCxrili: ', tanrigisCxrili);
    //console.log('userInput: ', userInput || 'NO INPUT YET');
    //console.log('forma6: ', forma6 || 'NO INPUT YET');
    //console.log('forma1: ', forma1 || 'NO INPUT YET');

    $scope.export = function (id) {
        Server.exportPassportDoc(id);
    };

    $scope.duplicate = function (id) {
        Server.createPassportDublicate(id).then(function (id) {
            $state.go('app.forest-cut-edit', {edit: id});
        });
    };

    // Get neccessary data from server for forms to build.

    $scope.agmonaceniAvailableClick = function () {

        if ($scope.userInput.agmonaceni_available) {
            $scope.userInput.shemadgenloba = undefined;
            $scope.userInput.mozard_agmonaceni_asaki = undefined;
            $scope.userInput.mozard_agmonaceni_simagle = undefined;
            $scope.userInput.mozard_agmonaceni_raodenoba = undefined;
            $scope.userInput.mozard_agmonaceni_mdgomareoba = undefined;

        }
    }

    $.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };


    $scope.logout = function () {
        User.logout().success(function (data) {
            if (data['msg'] === 'Ok') {
                $rootScope.authed = false;
                $state.go('login');
            }
        });
    };


    //FIXME: Don't like this solution. Mainly because it can affect other things.
    //TODO: Move this outside controller
    //Disable click for disabled tabs
    angular.element('li').on('click', function (e) {
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
            return false;
        }
    });

    /*
     $scope.$watch(checkLiteri, setLiter);

     function checkLiteri() {
     if ($scope.userInput) {
     return $scope.userInput.literi_available;
     }
     }

     function setLiter(newValue, oldValue) {
     if (newValue) {
     $scope.userInput.literi = undefined;
     }
     }*/

    $scope.$watch(function () {
        return $scope.userInput.mozard_agmonaceni_available;
    }, function (newVal) {
        if (newVal) {
            $scope.userInput.mozard_agmonaceni = "";
        } else {
            //console.log("unchecked");
        }
    });

    //$scope.userInput.mosargeble = "სს საქართველოს სახელმწიფო ელექტროსისტემა";
    //$scope.userInput.mosargebis_misamarti = "ქ. თბილისი ბარათაშვილი ქ. N2";

    // Dropdown initialization that does not require data from DB. Predefined values

    $scope.literebiDropdown = FormMaterials.rangeArrayLiters(1, 500);
    $scope.kvartaliDropdown = FormMaterials.rangeArray(1, 500);
    $scope.tyis_sixshireDropdown = FormMaterials.rangeArrayTyisSixshire(0.1, 1);
    $scope.eqspoziciaDropdown = FormMaterials.arrayExpozicia();
    $scope.chrisProcentiDropdown = FormMaterials.rangeArrayChrisProcenti(5, 100);
    $scope.daqanebaDropdown = FormMaterials.arrayStepDaqaneba(0, 30, 5);
    $scope.szdDropdown = FormMaterials.arrayStep(0, 3000, 250);
    $scope.xnovanebaDropdown = FormMaterials.rangeArray(0, 250, 5);
    $scope.mozardAgmonaceniDropdown = FormMaterials.arrayMozardAgmonaceni();
    $scope.zonebiDropdown = FormMaterials.arrayZona();
    $scope.chrisSaxeebiDropdown = FormMaterials.arrayChrisSaxeebi();
    $scope.agmonaceniAsakiDropdown = FormMaterials.rangeArray(5, 50, 5);
    $scope.agmonaceniSimagleDropdown = FormMaterials.rangeArrayAgmonaceniSimagle(.5, 3);
    $scope.agmonaceniMdgomareobaDropdown = [{value: 0, label: 'არადამაკმაყოფილებელი'},
        {value: 1, label: 'დამაკმაყოფილებელი'}];

    $scope.mdgomareobaDropdown = [{id: 0, label: "არადამაკმაყოფილებელი"}, {id: 1, label: "დამაკმაყოფილებელი"}];

    //Damakmayofilebeli/Aradamakmayofilebeli
    $scope.getMdgomareoba = function () {
        $scope.userInput.agmonaceni_mdgomareoba =
            Calc.getMdgomareoba($scope.userInput.tyis_sixshire_id, $scope.userInput.agmonaceni_simagle_id, $scope.userInput.agmonaceni_raodenoba);
    };

    $scope.$watch(function () {
        return $scope.userInput.tyis_sixshire_id;
    }, $scope.getMdgomareoba);
    $scope.$watch(function () {
        return $scope.userInput.agmonaceni_simagle_id;
    }, $scope.getMdgomareoba);
    $scope.$watch(function () {
        return $scope.userInput.agmonaceni_raodenoba;
    }, $scope.getMdgomareoba);


    var refreshOrganoDrops = function (newVal) {

        if ($scope.userInput.martvis_organo_id !== undefined && $scope.userInput.martvis_organo_id !== null) {
            $http.get('/api/dropdown-data/region/' + $scope.userInput.martvis_organo_id + '/only/').then(function (res) {
                $scope.regionebi = res.data.data;
            });
        }

        if ($scope.userInput.regioni_id !== undefined && $scope.userInput.regioni_id !== null) {
            $http.get('/api/dropdown-data/satyeo_ubani/' + $scope.userInput.regioni_id + '/only/').then(function (res) {
                $scope.satyeoUbnebi = res.data.data;
            });
        }

        if ($scope.userInput.satyeo_ubani_id !== undefined && $scope.userInput.satyeo_ubani_id !== null) {
            $http.get('/api/dropdown-data/satyeo/' + $scope.userInput.satyeo_ubani_id + '/only/').then(function (res) {
                $scope.satyeoebi = res.data.data;
            });
        }
    }

    $scope.$watch(function () {
        return $scope.userInput.martvis_organo_id;
    }, refreshOrganoDrops);
    $scope.$watch(function () {
        return $scope.userInput.regioni_id;
    }, refreshOrganoDrops);
    $scope.$watch(function () {
        return $scope.userInput.satyeo_ubani_id;
    }, refreshOrganoDrops);


    $scope.$watch(function () {
        return $scope.forma1Meta.saxeobaInputs;
    }, function () {

        var tmp = [];
        if ($scope.forma1Meta.saxeobaInputs) {
            for (var i = 0; i < $scope.forma1Meta.saxeobaInputs.length; i++) {
                if ($scope.forma1Meta.saxeobaInputs[i].saxeoba) { // Only if it is set
                    tmp.push($scope.forma1Meta.saxeobaInputs[i].saxeoba);
                }
            }
        }

        $scope.choosenSaxeobas = tmp;

        //Update tree factory input dropdown too

        $scope.choosenSaxeobasDrop = $scope.getChoosenSaxeobas();

    }, true);

    $scope.choosenSaxeobas = [];
    $scope.choosenSaxeobasDrop = [];

    $scope.getChoosenSaxeobas = function () {
        var ret = [];

        for (var i = 0; i < $scope.choosenSaxeobas.length; i++) {
            for (var j = 0; j < $scope.xisSaxeobas.length; j++) {
                if ($scope.choosenSaxeobas[i] == $scope.xisSaxeobas[j].id) {
                    ret.push($scope.xisSaxeobas[j]);
                }
            }
        }

        return ret;
    }

    $scope.addSaxeoba = function (saxeoba) { //Param is used for programmatical call
        var newItemNo = $scope.coords.length + 1;

        if (!saxeoba && !$scope.saxeobaFactory) {
            dialogs.error('შეცდომა', 'გთხოვთ აირჩიოთ სახეობა.');
            return;
        }

        if (!arrayContains($scope.choosenSaxeobas, ($scope.saxeobaFactory || saxeoba))) {
            $scope.forma1Meta.saxeobaInputs
                .push({saxeoba: ($scope.saxeobaFactory || saxeoba), x: undefined, y: undefined});
        } else {
            dialogs.error('შეცდომა', 'ეს სახეობა უკვე დამატებულია.');
        }

    };

    $scope.removeSaxeoba = function () {

        if ($scope.forma1Meta.saxeobaInputs.length <= 0) {
            dialogs.error('შეცდომა', 'ყველა სახეობა წაშლილია.');
            return;
        }

        var lastItem = $scope.forma1Meta.saxeobaInputs.length - 1;

        var removingSaxeoba = $scope.forma1Meta.saxeobaInputs[lastItem].saxeoba;

        //Return if there are trees in list with this saxeoba.

        if ($scope.userInput && $scope.f1.trees &&
            $scope.f1.trees.length > 0) {

            var usedSaxeobas = $scope.getUniqueSaxeobasFromTrees();

            if (removingSaxeoba && arrayContains(usedSaxeobas, removingSaxeoba)) {
                dialogs.error('შეცდომა', 'სახეობის წაშლა შეუძლებელია, ამ სახეობის ხეები უკვე დამატებულია.');
                return;
            }
        }

        // Reset model values for these fields, this also helps
        // to avoid sending hidden fields on server
        /*
         $scope.f1.saxeobebi[lastItem]
         = $scope.f1.saxeobebi[lastItem]
         = undefined;*/

        $scope.forma1Meta.saxeobaInputs.splice(lastItem);
    };

    $scope.getLabelById = function (array, id) {

        if (!array) {
            return "";
        }

        return _.findWhere(array, {id: id}).label;

        for (var i = 0; i < array.length; i++) {
            if (array[i].id == id) {
                return array[i].label;
            }
        }
    }

    //Get all saxeobas from tree list
    $scope.getUniqueSaxeobasFromTrees = function () {

        var ret = [];

        if ($scope.f1 && $scope.f1.trees) {
            for (var i = 0; i < $scope.f1.trees.length; i++) {
                ret.push($scope.f1.trees[i].saxeoba_id);
            }
        }

        return arrayUnique(ret);
    }

    $scope.enableStartNumber = function () {

        return $scope.userInput && $scope.f1.trees && $scope.f1.trees.length > 0;
    }

    //TEST FOR BIG DATA
    /*
     $timeout(function(){
     var i = 0;

     var diameters = getUniqueProperties($scope.xisDiametris, 'label');

     while(i < 8000){

     var rand = Math.random() * 200;
     //console.log("Random: ", rand, "Diameters: ", diameters);

     var res = closest(rand, diameters);

     $scope.f1.xisDiametri = res;

     //console.log($scope.f1.xisDiametri);

     $scope.addTree();
     i++;
     }

     }, 25000);*/

    $scope.addTree = function () {
        // In case userInput initializatoin is delayed by ajax request
        //TODO: Merge ajax response.data and existing userInput, instead of replacing.
        if (!$scope.f1.trees) {
            $scope.f1.trees = [];
        }

        updateTreeIndex();

        // It's ugly I know, thanks for notice
        if ($scope.f1
            && $scope.f1.xisSaxeoba
            && $scope.f1.xisDiametri
            && $scope.f1.xisXarisxi) {

            $scope.f1.trees.push({
                'nomeri': $scope.treeIndex,
                'saxeoba_id': $scope.f1.xisSaxeoba,
                'diametri_id': $scope.f1.xisDiametri,
                'xarisxi_id': $scope.f1.xisXarisxi
            });
        } else {
            dialogs.error('შეცდომა', 'ხის დასამატებლად ყველა ველი აუცილებელია');
        }
    }

    function updateTreeIndex(reverse) {
        if ($scope.f1.trees && $scope.f1.trees.length > 0) {
            if (reverse) {
                $scope.treeIndex--;
            } else {
                $scope.treeIndex++;
            }
        } else {
            $scope.treeIndex = ($scope.f1 && $scope.f1.startNumber) || 1;
        }
    }

    $scope.removeTree = function () {
        $scope.f1.trees.splice($scope.f1.trees.length - 1);
        updateTreeIndex(true);
    };

    $scope.removeFirstTree = function () {
        $scope.f1.trees.shift();
    };

    /*
     * ADD REMOVE TREES SMALLER THAN 6 IN DIAMETER
     *
     * Each item includes quantity property.
     */

    $scope.addSmallTreeGroup = function () {

        //console.log("Adding");

        if (
            $scope.f1.smallXisSaxeoba &&
            $scope.f1.smallXisDiametri &&
            $scope.f1.smallQuantity
        ) {

            var r = $scope.f1.smallXisDiametri / 2 / 100;

            var out = Math.PI * (r * r) * 15 * 0.75;

            $scope.forma1Meta.smallTrees.push({
                'saxeoba_id': $scope.f1.smallXisSaxeoba,
                'diametri': $scope.f1.smallXisDiametri,
                'xarisxi': 2,
                'geros_moculoba': /*out,*/ (0.01 * $scope.f1.smallQuantity),
                'saqmisi_merqani': /*out * .9,*/ (0.01 * $scope.f1.smallQuantity),
                'shesha_varjidan': /*out * .5,*/ 0,
                'xis_moculoba': /*(out * .9 + out * .5) * $scope.f1.smallQuantity,*/ (0.01 * $scope.f1.smallQuantity),
                'raodenoba': $scope.f1.smallQuantity
            });
        } else {
            dialogs.error('შეცდომა', 'ხის დასამატებლად ყველა ველი აუცილებელია');
        }
    }

    $scope.removeSmallTreeGroup = function (index) {
        if (index > -1) {
            $scope.forma1Meta.smallTrees.splice(index, 1);
        }
    }

    /*
     * AVERAGE DIAMETER CALCULATION
     */

    $scope.$watchCollection(function () {
        return $scope.f1.trees;
    }, function () {
        //console.log('trees array changed');
        calcAvgDiameters();
    });

    function calcAvgDiameters() {
        if ($scope.f1 && $scope.f1.trees) {

            $.each($scope.choosenSaxeobas, function (index, saxeoba) {
                var arr = $.map($scope.f1.trees, function (tree) {

                    //console.log('Comparison: ', tree.saxeoba_id, saxeoba);

                    if (tree.saxeoba_id == saxeoba) {
                        return tree;
                    }
                });

                //get list of diameter
                var diamteres = $.map(arr, function (el) {
                    return $scope.getLabelById($scope.xisDiametris, el.diametri_id);
                })/*.filter(function (value, index, self) { //Get only uniqs
                 return self.indexOf(value) === index;
                 })*/.sort(function (a, b) { // Sort numbers
                        return a - b;
                    });

                var sum = 0;
                $.each(diamteres, function (index, diam) {
                    sum += diam;
                });

                //console.log('diamteres: ', diamteres);

                sum = sum / diamteres.length;

                /*
                 var coef = diamteres.filter(function (value, index, self) { //Get only uniqs
                 return self.indexOf(value) === index;
                 }).length > 2 ? 59.7 : 50;*/

                sum = (sum * 50) / 50;

                var uniqDiamteres = diamteres.filter(function (value, index, self) { //Get only uniqs
                    return self.indexOf(value) === index;
                });

                var xisDiametris = $.map($scope.xisDiametris, function (el, i) {
                    return el.label;
                });

                var avg = closest(sum, xisDiametris);

                //console.log('xisDiametris: ', xisDiametris, sum);

                //diamteres[ Math.round(diamteres.length / 100 * 57.9) ];

                //console.log("Calculated averate, ", avg);

                //console.log($scope.forma1Meta);
                //console.log('AVGS: ', $scope.forma1Meta.avgDiameter);
                //console.log('INPUTS: ', $scope.forma1Meta.saxeobaInputs);
                $scope.forma1Meta && ($scope.forma1Meta.avgDiameter[saxeoba] = avg);

                $scope.updateSimaglesBySaxeoba(saxeoba, avg);
            });
        }
    }

    /*
     $scope.$watch(function(){return $scope.forma1Meta.avgDiameter;}, function(){
     console.log("avgDiameter changed");

     $.each($scope.xisSaxeobas, function(i, el){
     $scope.updateSimaglesBySaxeoba(el.id);
     });
     }, true);*/

    $scope.updateSimaglesBySaxeoba = function (saxeoba, avg) {

        //console.log("updateSimaglesBySaxeoba: ", saxeoba, avg);

        $scope.simaglesBySaxeoba[saxeoba] = getUniqueProperties(
            getListWhere($scope.tanrgisCxrili[saxeoba], 'diametri', avg),
            'simagle',
            true);

        //console.log("simaglesBySaxeoba: ", $scope.simaglesBySaxeoba[saxeoba], avg)
    }

    /*
     * AVERAGE HEIGHT CALCULATION
     */

    $scope.$watch(function () {
        return $scope.forma1Meta && ($scope.forma1Meta.hOne || $scope.forma1Meta.hTwo || $scope.forma1Meta.hThree);
    }, function () {
        /*if(!$scope.h){
         return;
         }*/
        /*
         $.each($scope.choosenSaxeobas, function(el, index){
         $scope.forma1Meta.h[index].avg = ($scope.forma1Meta.h[index].one
         + $scope.forma1Meta.h[index].two
         + $scope.forma1Meta.h[index].three) / 3;
         });*/

    }, true);


    /*
     * TANRIGI CALCULATION
     */

    $scope.calcTanrigi = function (saxeoba) {

        params = [];

        //params[0] = forma1Meta.avgDiameter[saxeoba];
        params[0] = $scope.forma1Meta.hOne[saxeoba];
        params[1] = $scope.forma1Meta.hTwo[saxeoba];
        params[2] = $scope.forma1Meta.hThree[saxeoba];

        //alert(JSON.stringify($scope.forma1Meta.hOne[saxeoba])); return;

        var tanrigs = [];

        $.each($scope.tanrgisCxrili[saxeoba], function (i, el) {

            $.each(params, function (j, h) {

                //console.log(el.diametri, $scope.forma1Meta.avgDiameter[saxeoba], el.simagle, h);

                if (el.diametri == $scope.forma1Meta.avgDiameter[saxeoba] && el.simagle == h) {

                    console.log("Got inside if.", el.tanrigi, el.simagle, h);

                    tanrigs.push(el.tanrigi);
                }
            });
        });

        if (tanrigs[0] && tanrigs[1] && tanrigs[2]) {

            //console.log("Calculating average tanrigi ", (tanrigs[0] + tanrigs[1] + tanrigs[2]) / 3);

            $scope.forma1Meta.tanrigi[saxeoba]
                = closest((tanrigs[0] + tanrigs[1] + tanrigs[2]) / 3, $scope.tanrigisBySaxeoba[saxeoba]);
        }

        //console.log("$scope.forma1Meta.tanrigi[saxeoba] : ", $scope.forma1Meta.tanrigi[saxeoba]);

        //console.log(Math.PI * ((8/2/100) * (8/2/100)) * 12 * 0.75); return;
    }

    $scope.calcTreeParams = function () {
        //This calculation depends on particular saxeoba's tanrigi

        //Check if tanrigi for this saxeoba is set

        $.each($scope.choosenSaxeobas, function (index, saxeoba) {
            var tanrgi = $scope.forma1Meta.tanrigi[saxeoba];

            if (!tanrgi) {
                dialogs.error('შეცდომა, კალკულაცია ვერ მოხერხდა', '"'
                    + $scope.getLabelById($scope.xisSaxeobas, saxeoba)
                    + '" სახეობის თანრიგი არ არის შერჩეული');
                return false;
            }

            var filteredByTanrigi = getListWhere($scope.tanrgisCxrili[saxeoba], 'tanrigi', tanrgi);

            //console.log('tanrgi: ', tanrgi);

            //console.log('filteredByTanrigi: ', filteredByTanrigi);

            //Walk on trees for this particular saxeoba
            $.each(getListWhere($scope.f1.trees, 'saxeoba_id', saxeoba), function (i, tree) {

                //console.log("Xis diametri: " , $scope.getLabelById($scope.xisDiametris, tree.diametri_id));

                var params = getListWhere(filteredByTanrigi, {'diametri': $scope.getLabelById($scope.xisDiametris, tree.diametri_id)});

                if (!(params.length > 0)) { //

                    //If tree already exsists and has enough params recalculate
                    if (tree.calcH && tree.calcF) {
                        $scope.manualCalc(tree);
                        return;
                    }

                    tree.noCalc = true;
                    return;
                }

                // Unset these in case they were provided when tree had
                // params that were unable to calulate automatically
                tree.calcH = tree.calcF = undefined;

                tree.noCalc = false;

                tree.geros_moculoba = params[0].geros_moculoba;
                tree.saqmisi_merqani = params[0].saqmisi_merqani;
                tree.shesha_varjidan = params[0].shesha_varjidan;
                tree.xis_moculoba = params[0].xis_moculoba;
            });
        });
    }

    // MANUAL CALCULATION OF TREE PARAMS

    $scope.manualCalc = function (tree) {

        if (!tree.calcH || !tree.calcF) {
            return;
        }

        var r = $scope.getLabelById($scope.xisDiametris, tree.diametri_id) / 2 / 100;

        var out = Math.PI * (r * r) * tree.calcH * tree.calcF;

        tree.geros_moculoba = parseFloat((out).toFixed(2));
        tree.saqmisi_merqani = parseFloat((out * .9).toFixed(2));
        tree.shesha_varjidan = parseFloat((out * (tree.saxeoba_id == 8 || tree.saxeoba_id == 1) ? 0 : 0.1).toFixed(2));
        tree.xis_moculoba = parseFloat((parseFloat(tree.saqmisi_merqani) + parseFloat(tree.shesha_varjidan)).toFixed(2));
        tree.calcShown = false;
    };

    $scope.submitClick = function () {

        if ($stateParams.edit) { // Edit - Update existing passport
            Server.updatePassport($stateParams.edit, $scope.userInput).then(function (responseData) {
                dialogs.notify("ტყეკაფის პასპორტი განახლდა", "პასპორტი წარმატებით განახლდა");
            }).catch(function () {
                dialogs.error("პასპორტი ვერ განახლდა", "შეამოწმეთ ინტერნეტთან კავშირი");
            });
        } else { //Create new passport
            Server.createPassport($scope.userInput).then(function (responseData) {

                dialogs.notify("ტყეკაფის პასპორტი შეიქმნა", "პასპორტი წარმატებით შეიქმნა");

                $state.go('app.forest-cut-edit', {edit: responseData.created_id});

                //console.log("Edit did run before this: ", JSON.stringify(responseData));
            }).catch(function (responseData) {

                dialogs.error("შეცდომა", "პასპორტი ვერ შეიქმნა");

            });
        }
    };

    $scope.f6SubmitClick = function () {

        //console.log($scope.userInput);
        //This is what we should send on server
        /*alert(JSON.stringify($scope.f6));
         return;*/

        if (!$scope.currentlyEditing) {
            dialogs.error("ფორმა 6 ვერ შეიქმნა",
                "ჯერ უნდა შეიქმნას პასსპორტი, გთხოვთ გადახვიდეთ პირველ ფანჯარაზე და შეიყვანოთ პასპორტის მონაცემები");
            return;
        }

        Server.updateForma6($scope.currentlyEditing, $scope.f6).then(function (res) {
            alert('Forma 6 updated.');
        }).catch(function (res) {
            alert('Forma 6 failed.');
        });
    };

    $scope.f1SubmitClick = function () {

        //alert(JSON.stringify($scope.forma1Meta.hOne[14])); return;

        if (!$scope.currentlyEditing) {
            dialogs.error("ფორმა 1 ვერ შეიქმნა",
                "ჯერ უნდა შეიქმნას პასსპორტი, გთხოვთ გადახვიდეთ პირველ ფანჯარაზე და შეიყვანოთ პასპორტის მონაცემები");
            return;
        }

        Server.updateForma1($scope.currentlyEditing, {
            meta: $scope.forma1Meta,
            trees: ($scope.f1 && $scope.f1.trees)
        }).then(function (res) {
            alert('Forma 1 updated.');
        }).catch(function (res) {
            alert('Forma 1 failed.');
        });

        //Server.updateForma1($scope.f1);
    };

    $scope.notCalculated = function (item) {
        return item.noCalc && !item.saqmisi_merqani && !item.shesha_varjidan;
    };
});